exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1EHH3I93idqD2PuwQL8tWP{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%}html[dir=ltr] ._1EHH3I93idqD2PuwQL8tWP,html[dir=rtl] ._1EHH3I93idqD2PuwQL8tWP{padding-right:12px;padding-left:12px}.CcCoC3ftkL8xZrt4QKeSn,._1wCIPJYuwU7sREr9owKM4U{width:100%}", ""]);
// Exports
exports.locals = {
	"emptyStateContainer": "_1EHH3I93idqD2PuwQL8tWP",
	"container": "CcCoC3ftkL8xZrt4QKeSn",
	"mainMessage": "_1wCIPJYuwU7sREr9owKM4U"
};